<div class="centered-container" [ngClass]="widthClass" [ngStyle]="customWidth">
  <ng-content></ng-content>
</div>
